import { Buffer } from "buffer";

// @ts-ignore
window.Buffer = Buffer;
